if (!customElements.get('multimedia-slider')) {
  customElements.define(
    'multimedia-slider',
    class MultimediaSlider extends HTMLElement {
      constructor() {
        super()
        this.swiper = new Swiper(this.querySelector('[data-media-swiper]'), {
          speed: 500,
          effect: 'fade',
          loop: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        })
        setTimeout(() => {
          this.initButtons()
        }, 1000)
      }
      initButtons() {
        this.querySelectorAll('[data-prev-slide]').forEach((prevBtn) => {
          prevBtn.addEventListener('click', (e) => {
            this.swiper.slidePrev()
          })
        })
        this.querySelectorAll('[data-next-slide]').forEach((nextBtn) => {
          nextBtn.addEventListener('click', (e) => {
            this.swiper.slideNext()
          })
        })
      }
    },
  )
}
